<ion-header>
  <ion-toolbar>
    <ion-title>Find device</ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content ion-padding">
  <form (ngSubmit)="find()">
    <ion-item class="ion-margin-vertical">
      <ion-icon slot="start" name="search-outline"></ion-icon>
      <app-device-input [error]="error" (newDevice)="newDevice($event)" [disabledCalibration]="true"></app-device-input>
    </ion-item>

    <ion-button type="submit" expand="full" [disabled]="!deviceId || deviceId.length < 3" class="ion-no-margin">
      Find
    </ion-button>
  </form>
</div>
  